import { useMemo } from 'react';

type PropsPagination<T> = {
    currentPage: number;
    itemsPerPage: number;
    data: T[];
};

export function usePaginatedData<T>({
                                        currentPage,
                                        itemsPerPage,
                                        data,
                                    }: PropsPagination<T>): T[] {
    return useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return data.slice(startIndex, startIndex + itemsPerPage);
    }, [currentPage, itemsPerPage, data]);
}
